const serviceName = '/service/memories'
export default serviceName
